module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('div', {
    staticClass: "loading"
  }, [_c('svg', {
    attrs: {
      "viewBox": "-2000 -1000 4000 2000"
    }
  }, [_c('path', {
    attrs: {
      "id": "inf",
      "d": "M354-354A500 500 0 1 1 354 354L-354-354A500 500 0 1 0-354 354z"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "xlink:href": "#inf",
      "stroke-dasharray": "1570 5143",
      "stroke-dashoffset": "6713px"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7b3ccdc6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 559
// module chunks = 1